var ProductListConfig = (function() {
    var PRODUCT_LIST = {
        "mapa-astral": {
            id: 3,

            modalSteps: ["profile-select"],

            miniEndpoint: "/product/astrologyChart/ajaxCreateSimpleAnalisys",
            miniResultUrl: "/astrologia/mapa-astral/mini/resultado/",

            completeEndpoint: "/product/astrologyChart/ajaxCreate",
            completeResultUrl: "/astrologia/mapa-astral/completo/resultado/",

            buildMiniAjaxParams: function(profileData, siteID) {
                var params = {
                    "AstrologyChart[id_profile]": profileData.profileID,
                    "AstrologyChart[id_site]": siteID,
                    "AstrologyChart[generatedProduct_code]":
                        profileData.productCode
                };

                return params;
            },

            buildCompleteAjaxParams: function(profileData, siteID) {
                var params = {
                    "AstrologyChart[id_profile]": profileData.profileID,
                    "AstrologyChart[id_site]": siteID,
                    "AstrologyChart[generatedProduct_code]":
                        profileData.productCode,
                    "AstrologyChart[generatedProduct_status]":
                        PRODUCT_STATUS.GENERATED
                };

                return params;
            }
        },

        "revolucao-solar": {
            id: 8,

            modalSteps: ["profile-select", "profile-solar-revolution"],

            miniEndpoint:
                "/product/AstrologySolarRevolution/ajaxCreateSimpleAnalisys",
            miniResultUrl: "/astrologia/revolucao-solar/mini/resultado/",

            completeEndpoint: "/product/AstrologySolarRevolution/ajaxCreate",
            completeResultUrl:
                "/astrologia/revolucao-solar/completo/resultado/",

            buildMiniAjaxParams: function(profileData, siteID) {
                var params = {
                    "AstrologySolarRevolution[id_profile]":
                        profileData.profileID,
                    "AstrologySolarRevolution[id_site]": siteID,
                    "AstrologySolarRevolution[generatedProduct_code]":
                        profileData.productCode,
                    "AstrologySolarRevolution[solar_id_city]": profileData.city,
                    "AstrologySolarRevolution[solar_birthdate]":
                        profileData.solarRevolutionYear,
                    "AstrologySolarRevolution[generatedProduct_status]":
                        PRODUCT_STATUS.GENERATED
                };

                return params;
            },

            buildCompleteAjaxParams: function(profileData, siteID) {
                var params = {
                    "AstrologySolarRevolution[id_profile]":
                        profileData.profileID,
                    "AstrologySolarRevolution[id_site]": siteID,
                    "AstrologySolarRevolution[generatedProduct_code]":
                        profileData.productCode,
                    "AstrologySolarRevolution[solar_id_city]": profileData.city,
                    "AstrologySolarRevolution[solar_birthdate]":
                        profileData.solarRevolutionYear,
                    "AstrologySolarRevolution[generatedProduct_status]":
                        PRODUCT_STATUS.GENERATED
                };

                return params;
            }
        },

        "mapa-do-ano": {
            id: 24,

            modalSteps: ["profile-select", "profile-numerology-year"],

            miniEndpoint: "/product/numerologyYear/ajaxCreateSimpleAnalisys",
            miniResultUrl: "/numerologia/mapa-do-ano/mini/resultado/",

            completeEndpoint: "/product/numerologyYear/ajaxCreate",
            completeResultUrl: "/numerologia/mapa-do-ano/completo/resultado/",

            buildMiniAjaxParams: function(profileData, siteID) {
                var params = {
                    "NumerologyYear[id_profile]":
                        profileData.numerologyProfileId,
                    "NumerologyYear[id_site]": siteID,
                    "NumerologyYear[generatedProduct_code]":
                        profileData.productCode,
                    "NumerologyYear[username]":
                        profileData.numerologyProfileName,
                    "NumerologyYear[gender]":
                        profileData.numerologyProfileGender,
                    "NumerologyYear[birthdate]":
                        profileData.numerologyProfileBirthDate,
                    "NumerologyYear[year]": profileData.numerologyProfileYear
                };

                return params;
            },

            buildCompleteAjaxParams: function(profileData, siteID) {
                var params = {
                    "NumerologyYear[id_profile]":
                        profileData.numerologyProfileId,
                    "NumerologyYear[id_site]": siteID,
                    "NumerologyYear[generatedProduct_code]":
                        profileData.productCode,
                    "NumerologyYear[username]":
                        profileData.numerologyProfileName,
                    "NumerologyYear[gender]":
                        profileData.numerologyProfileGender,
                    "NumerologyYear[birthdate]":
                        profileData.numerologyProfileBirthDate,
                    "NumerologyYear[year]": profileData.numerologyProfileYear,
                    "NumerologyYear[generatedProduct_status]":
                        PRODUCT_STATUS.GENERATED
                };

                return params;
            }
        },

        "mapa-sexual": {
            id: 25,

            modalSteps: ["profile-select"],

            miniEndpoint:
                "/product/astrologySexualityChart/ajaxCreateSimpleAnalisys",
            miniResultUrl: "/astrologia/mapa-sexual/mini/resultado/",

            completeEndpoint: "/product/astrologySexualityChart/ajaxCreate",
            completeResultUrl: "/astrologia/mapa-sexual/completo/resultado/",

            buildMiniAjaxParams: function(profileData, siteID) {
                var params = {
                    "AstrologySexualityChart[id_profile]":
                        profileData.profileID,
                    "AstrologySexualityChart[id_site]": siteID,
                    "AstrologySexualityChart[generatedProduct_code]":
                        profileData.productCode
                };

                return params;
            },

            buildCompleteAjaxParams: function(profileData, siteID) {
                var params = {
                    "AstrologySexualityChart[id_profile]":
                        profileData.profileID,
                    "AstrologySexualityChart[id_site]": siteID,
                    "AstrologySexualityChart[generatedProduct_code]":
                        profileData.productCode,
                    "AstrologySexualityChart[generatedProduct_status]":
                        PRODUCT_STATUS.GENERATED
                };

                return params;
            }
        },

        "mapa-numerologico": {
            id: 6,

            modalSteps: ["profile-select", "profile-numerology"],

            miniEndpoint:
                "/product/numerologyAnalisys/ajaxCreateSimpleAnalisys",
            miniResultUrl: "/numerologia/mapa-numerologico/mini/resultado/",

            completeEndpoint: '/product/numerologyAnalisys/ajaxCreate',
            completeResultUrl: '/numerologia/mapa-numerologico/completo/resultado/',

            buildMiniAjaxParams: function(profileData, siteID) {
                var params = {
                    "NumerologyAnalisys[id_profile]": profileData.profileID,
                    "NumerologyAnalisys[id_site]": siteID,
                    "NumerologyAnalisys[generatedProduct_code]":
                        profileData.productCode,
                    "NumerologyAnalisys[username]":
                        profileData.numerologyProfileName,
                    "NumerologyAnalisys[gender]":
                        profileData.numerologyProfileGender,
                    "NumerologyAnalisys[birthdate]":
                        profileData.numerologyProfileBirthDate,
                    "NumerologyAnalisys[year]":
                        profileData.numerologyProfileYear,
                    "NumerologyAnalisys[generatedProduct_status]":
                        PRODUCT_STATUS.GENERATED
                };

                return params;
            },

            buildCompleteAjaxParams: function(profileData, siteID) {
                var params = {
                    "NumerologyAnalisys[id_profile]": profileData.profileID,
                    "NumerologyAnalisys[id_site]": siteID,
                    "NumerologyAnalisys[generatedProduct_code]":
                        profileData.productCode,
                    "NumerologyAnalisys[username]":
                        profileData.numerologyProfileName,
                    "NumerologyAnalisys[gender]":
                        profileData.numerologyProfileGender,
                    "NumerologyAnalisys[birthdate]":
                        profileData.numerologyProfileBirthDate,
                    "NumerologyAnalisys[year]":
                        profileData.numerologyProfileYear,
                    "NumerologyAnalisys[generatedProduct_status]":
                        PRODUCT_STATUS.GENERATED
                };

                return params;
            }
        },

        "mapa-do-amor": {
            id: 19,

            modalSteps: ["profile-select", "profile-numerology"],

            miniEndpoint: "/product/numerologyLove/ajaxCreateSimpleAnalisys",
            miniResultUrl: "/numerologia/mapa-do-amor/mini/resultado/",

            completeEndpoint: "/product/numerologyLove/ajaxCreate",
            completeResultUrl: "/numerologia/mapa-do-amor/completo/resultado/",

            buildMiniAjaxParams: function(profileData, siteID) {
                var params = {
                    "NumerologyLove[id_profile]": profileData.profileID,
                    "NumerologyLove[id_site]": siteID,
                    "NumerologyLove[generatedProduct_code]":
                        profileData.productCode,
                    "NumerologyLove[username]":
                        profileData.numerologyProfileName,
                    "NumerologyLove[gender]":
                        profileData.numerologyProfileGender,
                    "NumerologyLove[birthdate]":
                        profileData.numerologyProfileBirthDate,
                    "NumerologyLove[year]": -1,
                    "NumerologyLove[generatedProduct_status]":
                        PRODUCT_STATUS.GENERATED
                };

                return params;
            },

            buildCompleteAjaxParams: function(profileData, siteID) {
                var params = {
                    "NumerologyLove[id_profile]": profileData.profileID,
                    "NumerologyLove[id_site]": siteID,
                    "NumerologyLove[generatedProduct_code]":
                        profileData.productCode,
                    "NumerologyLove[username]":
                        profileData.numerologyProfileName,
                    "NumerologyLove[gender]":
                        profileData.numerologyProfileGender,
                    "NumerologyLove[birthdate]":
                        profileData.numerologyProfileBirthDate,
                    "NumerologyLove[year]": -1,
                    "NumerologyLove[generatedProduct_status]":
                        PRODUCT_STATUS.GENERATED
                };

                return params;
            }
        },

        'previsoes-numerologicas': {
            id: 23,

            modalSteps: ['profile-select', 'profile-numerology-forecast'],

            miniEndpoint: '/product/numerologyForecast/ajaxCreateSimpleAnalisys',
            miniResultUrl: '/numerologia/previsoes-numerologicas/mini/resultado/',

            completeEndpoint: '/product/numerologyForecast/ajaxCreate',
            completeResultUrl: '/numerologia/previsoes-numerologicas/completo/resultado/',

            buildMiniAjaxParams: function (profileData, siteID) {
                var params = {
                    'NumerologyForecast[id_profile]': profileData.profileID,
                    'NumerologyForecast[id_site]': siteID,
                    'NumerologyForecast[generatedProduct_code]': profileData.productCode,
                    'NumerologyForecast[username]': profileData.numerologyForecastUserProfileName,
                    'NumerologyForecast[gender]': profileData.numerologyForecastProfileGender,
                    'NumerologyForecast[birthdate]': profileData.numerologyForecastProfileBirthDate,
                    'NumerologyForecast[year]': profileData.numerologyProfileTrimester.split('-')[1],
                    'NumerologyForecast[trimester]': profileData.numerologyProfileTrimester.split('-')[0],
                    'NumerologyForecast[generatedProduct_status]': PRODUCT_STATUS.GENERATED
                };

                return params;
            },

            buildCompleteAjaxParams: function (profileData, siteID) {
                var params = {
                    'NumerologyForecast[id_profile]': profileData.profileID,
                    'NumerologyForecast[id_site]': siteID,
                    'NumerologyForecast[generatedProduct_code]': profileData.productCode,
                    'NumerologyForecast[username]': profileData.numerologyForecastUserProfileName,
                    'NumerologyForecast[gender]': profileData.numerologyForecastProfileGender,
                    'NumerologyForecast[birthdate]': profileData.numerologyForecastProfileBirthDate,
                    'NumerologyForecast[year]': profileData.numerologyProfileTrimester.split('-')[1],
                    'NumerologyForecast[trimester]': profileData.numerologyProfileTrimester.split('-')[0],
                    'NumerologyForecast[generatedProduct_status]': PRODUCT_STATUS.GENERATED
                };

                return params;
            }
        },

        "mapa-infantil": {
            id: 18,

            modalSteps: ["profile-select", "profile-numerology"],

            miniEndpoint: "/product/numerologyChild/ajaxCreateSimpleAnalisys",
            miniResultUrl: "/numerologia/mapa-infantil/mini/resultado/",

            completeEndpoint: "/product/numerologyChild/ajaxCreate",
            completeResultUrl: "/numerologia/mapa-infantil/completo/resultado/",

            buildMiniAjaxParams: function(profileData, siteID) {
                var params = {
                    "NumerologyChild[id_profile]": profileData.profileID,
                    "NumerologyChild[id_site]": siteID,
                    "NumerologyChild[generatedProduct_code]":
                        profileData.productCode,
                    "NumerologyChild[username]":
                        profileData.numerologyProfileName,
                    "NumerologyChild[gender]":
                        profileData.numerologyProfileGender,
                    "NumerologyChild[birthdate]":
                        profileData.numerologyProfileBirthDate,
                    "NumerologyChild[year]": -1,
                    "NumerologyChild[generatedProduct_status]":
                        PRODUCT_STATUS.GENERATED
                };

                return params;
            },

            buildCompleteAjaxParams: function(profileData, siteID) {
                var params = {
                    "NumerologyChild[id_profile]": profileData.profileID,
                    "NumerologyChild[id_site]": siteID,
                    "NumerologyChild[generatedProduct_code]":
                        profileData.productCode,
                    "NumerologyChild[username]":
                        profileData.numerologyProfileName,
                    "NumerologyChild[gender]":
                        profileData.numerologyProfileGender,
                    "NumerologyChild[birthdate]":
                        profileData.numerologyProfileBirthDate,
                    "NumerologyChild[year]": -1,
                    "NumerologyChild[generatedProduct_status]":
                        PRODUCT_STATUS.GENERATED
                };

                return params;
            }
        }
    };

    return {
        getProductList: function() {
            return PRODUCT_LIST;
        }
    };
})();
